import "../assets/css/_variables.scss"; // Import the CSS file

export const CODE_2FA_MIN_LENGTH = 4;
export const PASSWORD_MIN_CHAR = 8;

export const GOOGLE_CAPTCHA_RESPONSE_KEY = "g-recaptcha-response";

export const REFRESH_TOKEN = "refresh_token";

export const DELETE_CONFIRMATION: any = {
  title: "Are you sure?",
  text: "You won't be able to revert this!",
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: "var(--primary)",
  cancelButtonColor: "#d33",
  confirmButtonText: "Yes, delete it!",
};

export const CHANGE_CONFIRMATION: any = {
  title: "Please confirm",
  text: "Are you sure to change the status of user?",
  icon: "question",
  showCancelButton: true,
  confirmButtonColor: "var(--primary)",
  cancelButtonColor: "#d33",
  confirmButtonText: "Yes",
  cancelButtonText: "No",
};

export const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg"];
export const MAX_FILE_SIZE_IN_BYTES = 1024 * 1024 * 2; // 1MB

export const GLOBAL_DEFAULT = {
  CURRENT_PAGE: 1,
  LOADER_STATE: false,
  MODAL_STATE: false,
  PAGINATOR_ROWS: 10,
  PAGINATOR_FIRST: 0,
  SEARCH_STATE: "",
  SORT_FIELD: "id",
  SORT_ORDER: "DESC",
  ROW_PER_PAGE_10: 10,
  ROW_PER_PAGE_20: 20,
  ROW_PER_PAGE_50: 50,
  ROW_PER_PAGE_100: 100,
  HIDE_TABLE_PAGINATOR: true,
  CUSTOM_PAGINATOR_VALUES: [10, 20, 50, 100],
};
